export const createImage = src => {
  // as this is not a critical task, we do not reject this promise
  // to prevent an entire page not functioning because of this
  return new Promise(resolve => {
    const img = new Image();

    img.src = src;

    img.onload = () => {
      resolve(img);
    };

    img.onerror = () => resolve(null);
  });
};
